/** Local calendar days match the dates displayed in the member's browser. */
export function memberActivityDays(activity: string[], now = new Date()) {
  const counts = new Map<string, number>();
  for (const iso of activity) {
    const date = new Date(iso);
    if (!Number.isFinite(date.getTime()) || date > now) continue;
    const key = date.toDateString();
    counts.set(key, (counts.get(key) || 0) + 1);
  }
  return Array.from({length:15}, (_,index) => {
    const day = new Date(now); day.setDate(day.getDate() - 14 + index); day.setHours(0,0,0,0);
    return {date:day, count:counts.get(day.toDateString()) || 0, isToday:index === 14};
  });
}
